// extracted by mini-css-extract-plugin
export default {"createNewButtonContainer":"BarrierSettings_createNewButtonContainer_IASnY","createNewButton":"BarrierSettings_createNewButton_HbBEs","spinAround":"BarrierSettings_spinAround_aRcr5"};